module.exports = __webpack_public_path__ + "img/test-icon.1fea0875.png";